// index.js
// ChartView - main view with collapsible sidebar and chart area

// Imports
import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import Sidebar from './Sidebar';
import SalesChart from './SalesChart';
import ClientSalesChart from './ClientSalesChart';
import ProductSalesChart from './ProductSalesChart';
import ProductVolumesChart from './ProductVolumesChart';
import './styles/style.css';

// Available chart types
const CHARTS = [
  { id: 'sales', label: 'Vendas ao Longo do Tempo', path: '/chart/sales', icon: 'timeline-line-chart' },
  { id: 'clientSales', label: 'Vendas por Cliente', path: '/chart/sales/clients', icon: 'people' },
  { id: 'productSales', label: 'Vendas por Produto', path: '/chart/sales/products', icon: 'shop' },
  { id: 'productVolumes', label: 'Volume por Produto', path: '/chart/sales/volumes', icon: 'stacked-chart' },
];

// Component Class
// Renders the Charts page with a collapsible sidebar and a chart main area
class ChartView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: true,
    };
  }

  toggleSidebar = () => {
    this.setState(s => ({ sidebarOpen: !s.sidebarOpen }));
  }

  handleSelectChart = (chartId) => {
    const chart = CHARTS.find(c => c.id === chartId);
    if (chart && this.props.history) {
      this.props.history.push(chart.path);
    }
  }

  // Renders the chart component for the currently selected chart type
  renderChart() {
    const { orders, products, clients } = this.props;
    return (
      <Switch>
        <Route exact path="/chart/sales/clients" render={() => <ClientSalesChart orders={orders} products={products} clients={clients} />} />
        <Route exact path="/chart/sales/products" render={() => <ProductSalesChart orders={orders} products={products} />} />
        <Route exact path="/chart/sales/volumes" render={() => <ProductVolumesChart orders={orders} products={products} />} />
        <Route exact path="/chart/sales" render={() => <SalesChart orders={orders} products={products} />} />
        <Redirect from="/chart" to="/chart/sales" />
      </Switch>
    );
  }

  // Renders Component
  render() {
    const { sidebarOpen } = this.state;
    const { location } = this.props;
    
    // Determine the active item for the sidebar
    // We reverse the array to match more specific paths (like /clients) first if making a prefix check,
    // but here exact match is fine.
    const currentChartObj = CHARTS.find(c => location && location.pathname === c.path);
    const selectedChart = currentChartObj ? currentChartObj.id : CHARTS[0].id;

    return (
      <div className="chart-view">
        <div className="chart-view__sidebar-area">
          <Sidebar
            isOpen={sidebarOpen}
            charts={CHARTS}
            selectedChart={selectedChart}
            onSelect={this.handleSelectChart}
            onToggle={this.toggleSidebar}
          />
        </div>
        <div className="chart-view__main">
          {this.renderChart()}
        </div>
      </div>
    );
  }
}

// Required Properties
ChartView.propTypes = {
  orders: PropTypes.object.isRequired,
  products: PropTypes.object.isRequired,
  clients: PropTypes.object.isRequired,
  history: PropTypes.object,
  location: PropTypes.object,
};

// Exports
export default ChartView;



// WEBPACK FOOTER //
// ./src/components/ChartView/index.js